import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config/config';

export default class Alert extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    global: PropTypes.bool,
    noClose: PropTypes.bool,
    onFinished: PropTypes.func,
    style: PropTypes.object,
    timeout: PropTypes.number,
    type: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
  }

  static defaultProps = {
    global: false,
    noClose: false,
    timeout: config.ux.alertTimeout, // Setting a timeout of false or -1 will force the user to have to dismiss it (at least till another alert comes along)
    type: 'danger',
  }

  constructor(props) {
    super(props);
    this.state = {display: true};
  }

  componentDidMount = () => {
    this.runTimeout();
  }

  componentWillReceiveProps = () => {
    // Reset the alert
    this.setState({
      display: true,
    });
    clearTimeout(this.timeout);
    this.runTimeout();
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  }

  close = () => {
    if(this.props.onFinished) {
      this.props.onFinished();
    } else {
      this.setState({
        display: false,
      });
    }
  }

  runTimeout = () => {
    if (!!this.props.timeout && this.props.timeout >= 0) {
      this.timeout = setTimeout(this.close, this.props.timeout);
    }
  }

  onMouseEnter = () => {
    clearTimeout(this.timeout);
  }

  onMouseLeave = () => {
    this.runTimeout();
  }

  render() {
    const {
      type,
      className,
      children,
      global,
      noClose,
      style,
      } = this.props;

    const classes = {
      alert: true,
      'site-alert': true,
      'local-alert': !global,
    };

    if (type) {
      classes['alert-' + type] = true;
    }

    const styleRoot = Object.assign({}, {
      display: this.state.display ? 'block' : 'none',
    },
      style,
    );

    return <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
      className={classNames(className, classes)} style={styleRoot}>
      <div className="alert-container">
        {children}
        {!noClose ? <button type="button" className="alert-close" onClick={this.close}>&times;</button> : null}
      </div>
    </div>;
  }
};



// WEBPACK FOOTER //
// ./src/modules/shared/alert/components/alert.js